export const CONCIERGE_RETURN_KEY = 'manor.admin.concierge-request';

export function conciergeRequestFromSearch(search: string): string | null {
  const id = new URLSearchParams(search).get('request');
  return id && /^MC-[a-f0-9]{24}$/.test(id) ? id : null;
}

export function conciergeRequestPath(id: string): string {
  return /^MC-[a-f0-9]{24}$/.test(id) ? `/concierge?request=${id}` : '/';
}
